// const alohaThemeSet = new Set();
// const brannanThemeSet = new Set();

// const alohaScreenshots = [];
// const brannanScrenshots = [];

// const processExhibit = (exhibit, targetThemeSet, targetScreenshotArray) => {
//   if (targetScreenshotArray.length < 15) {
//     const styleId = exhibit.spec.style.id;
//     if (!targetThemeSet.has(styleId)) {
//       targetScreenshotArray.push(exhibit);
//       targetThemeSet.add(styleId)
//     }
//   }
// }

// showcase.exhibits.forEach(exhibit => {
//   let targetThemeSet;
//   let targetScreenshotArray;
//   if (exhibit.spec.websiteLayout.template === 'aloha') {
//     processExhibit(exhibit, alohaThemeSet, alohaScreenshots);
//   } else {
//     processExhibit(exhibit, brannanThemeSet, brannanScrenshots);
//   }
//   if (alohaScreenshots.length > 15 && brannanScrenshots.length > 15)   {
//     return;
//   }
// });

// const result = [];
// for (let index = 0; index < 15; index++) {
//   result.push(alohaScreenshots[index]);
//   result.push(brannanScrenshots[index]);
// }

export const DEFAULT_EXHIBIT_DATA = [
  {
    exhibitId: 'ae9d63a8e71b4b6bb98c6d5508bf37ca0315292c77234ef3e9e85e0768ff3418',
    aspectRatio: 1.6,
    thumbnail: {
      url:
        'https://d2ytcdhzgn2xcf.cloudfront.net/assets/public/designShowcase/1564430193037/ae9d63a8e71b4b6bb98c6d5508bf37ca0315292c77234ef3e9e85e0768ff3418.png?resize=w800'
    },
    spec: {
      owner: 'Emily Martin',
      fiancee: 'Oliver Leede',
      message: `We're getting married, and we want you to be there!`,
      style: { id: 'branching_out', name: 'Branching Out', supportsPrints: false, supportsEcards: true },
      fontName: 'Komu',
      primaryPhotoHorizontal: {
        assetId: '3RxGW703RAWlkJSA52mL_w_couple_emily_oliver_hugging_laughing.jpg',
        width: 3408,
        height: 5112
      },
      palette: {
        paletteId: '#fffefb-false',
        paletteName: 'My Custom Color',
        accentColor: { hexString: 'fffefbff', floatArray: [1, 0.996078, 0.984314, 1] },
        baseText: { hexString: '000000ff', floatArray: [0, 0, 0, 1] },
        baseColor: { hexString: 'fffefbff', floatArray: [1, 0.996078, 0.984314, 1] },
        accentText: { hexString: '000000ff', floatArray: [0, 0, 0, 1] },
        accentLightText: false,
        baseLightText: false
      },
      usesWeddingColor: false,
      websiteLayout: { template: 'aloha' }
    },
    organizationBuckets: [
      {
        bucketId: 'botanical_nature',
        bucketGroupId: 'themes',
        displayString: 'Nature & Botanical',
        displayRGBAColor: null
      },
      {
        bucketId: 'beige',
        bucketGroupId: 'colors',
        displayString: 'Beige',
        displayRGBAColor: {
          hexString: 'efeee2ff',
          floatArray: [0.9372549019607843, 0.9333333333333333, 0.8862745098039215, 1]
        }
      },
      {
        bucketId: 'white',
        bucketGroupId: 'colors',
        displayString: 'White',
        displayRGBAColor: { hexString: 'ffffffff', floatArray: [1, 1, 1, 1] }
      },
      {
        bucketId: 'green',
        bucketGroupId: 'colors',
        displayString: 'Green',
        displayRGBAColor: {
          hexString: '9aa493ff',
          floatArray: [0.6039215686274509, 0.6431372549019608, 0.5764705882352941, 1]
        }
      }
    ]
  },
  {
    exhibitId: '5bce194af8a014b5497727597cce21b83a29d4cb6f6a1f676d29d967382a4825',
    aspectRatio: 1.6,
    thumbnail: {
      url:
        'https://d2ytcdhzgn2xcf.cloudfront.net/assets/public/designShowcase/1564430193037/5bce194af8a014b5497727597cce21b83a29d4cb6f6a1f676d29d967382a4825.png?resize=w800'
    },
    spec: {
      owner: 'Isabella Hernandez',
      fiancee: 'Valentina Jones',
      message: 'Get ready to class it up. December 2018.',
      style: { id: 'fionas_flowers', name: `Fiona's Flowers`, supportsPrints: false, supportsEcards: true },
      fontName: 'Alegreya Sans SC',
      primaryPhotoHorizontal: {
        assetId: 'BO00HjXgSq6h5eq2WlUw_bg_couple_isabella_valentina_botanical.jpg',
        width: 4000,
        height: 6000
      },
      palette: {
        paletteId: '#fafafa-false',
        paletteName: 'My Custom Color',
        accentColor: { hexString: 'fafafaff', floatArray: [0.980392, 0.980392, 0.980392, 1] },
        baseText: { hexString: '000000ff', floatArray: [0, 0, 0, 1] },
        baseColor: { hexString: 'fafafaff', floatArray: [0.980392, 0.980392, 0.980392, 1] },
        accentText: { hexString: '000000ff', floatArray: [0, 0, 0, 1] },
        accentLightText: false,
        baseLightText: false
      },
      usesWeddingColor: true,
      websiteLayout: { template: 'aloha' }
    },
    organizationBuckets: [
      {
        bucketId: 'botanical_nature',
        bucketGroupId: 'themes',
        displayString: 'Nature & Botanical',
        displayRGBAColor: null
      },
      { bucketId: 'floral', bucketGroupId: 'themes', displayString: 'Floral', displayRGBAColor: null },
      {
        bucketId: 'beige',
        bucketGroupId: 'colors',
        displayString: 'Beige',
        displayRGBAColor: {
          hexString: 'efeee2ff',
          floatArray: [0.9372549019607843, 0.9333333333333333, 0.8862745098039215, 1]
        }
      },
      {
        bucketId: 'red',
        bucketGroupId: 'colors',
        displayString: 'Red',
        displayRGBAColor: {
          hexString: 'b8564fff',
          floatArray: [0.7215686274509804, 0.33725490196078434, 0.30980392156862746, 1]
        }
      },
      {
        bucketId: 'blue',
        bucketGroupId: 'colors',
        displayString: 'Blue',
        displayRGBAColor: {
          hexString: '7096c5ff',
          floatArray: [0.4392156862745098, 0.5882352941176471, 0.7725490196078432, 1]
        }
      },
      {
        bucketId: 'green',
        bucketGroupId: 'colors',
        displayString: 'Green',
        displayRGBAColor: {
          hexString: '9aa493ff',
          floatArray: [0.6039215686274509, 0.6431372549019608, 0.5764705882352941, 1]
        }
      },
      {
        bucketId: 'pink',
        bucketGroupId: 'colors',
        displayString: 'Pink',
        displayRGBAColor: {
          hexString: 'dea3c2ff',
          floatArray: [0.8705882352941177, 0.6392156862745098, 0.7607843137254902, 1]
        }
      },
      {
        bucketId: 'purple',
        bucketGroupId: 'colors',
        displayString: 'Purple',
        displayRGBAColor: {
          hexString: '956db1ff',
          floatArray: [0.5843137254901961, 0.42745098039215684, 0.6941176470588235, 1]
        }
      },
      {
        bucketId: 'white',
        bucketGroupId: 'colors',
        displayString: 'White',
        displayRGBAColor: { hexString: 'ffffffff', floatArray: [1, 1, 1, 1] }
      }
    ]
  },
  {
    exhibitId: '1122513776d064c64b79001f111fb8fd197bba268adfad932d8a80ebd440ecc5',
    aspectRatio: 1.6,
    thumbnail: {
      url:
        'https://d2ytcdhzgn2xcf.cloudfront.net/assets/public/designShowcase/1564430193037/1122513776d064c64b79001f111fb8fd197bba268adfad932d8a80ebd440ecc5.png?resize=w800'
    },
    spec: {
      owner: 'Carly Hobbins',
      fiancee: 'John Mesnick',
      message: `We're getting married! And we want you to be there!`,
      style: { id: 'raspberry_sherbet', name: 'Raspberry Sherbet', supportsPrints: false, supportsEcards: true },
      fontName: 'Great Vibes',
      primaryPhotoHorizontal: {
        assetId: 'DkAwwJd3QgqhbN1htK8y_w_couple_carly_john_excited_piggyback.jpg',
        width: 5184,
        height: 3456
      },
      palette: {
        paletteId: '#f9c1b8-false',
        paletteName: 'My Custom Color',
        accentColor: { hexString: 'f9c1b8ff', floatArray: [0.976471, 0.756863, 0.721569, 1] },
        baseText: { hexString: '000000ff', floatArray: [0, 0, 0, 1] },
        baseColor: { hexString: 'f9c1b8ff', floatArray: [0.976471, 0.756863, 0.721569, 1] },
        accentText: { hexString: '000000ff', floatArray: [0, 0, 0, 1] },
        accentLightText: false,
        baseLightText: false
      },
      usesWeddingColor: false,
      websiteLayout: { template: 'aloha' }
    },
    organizationBuckets: [
      {
        bucketId: 'simple_classic',
        bucketGroupId: 'themes',
        displayString: 'Simple & Classic',
        displayRGBAColor: null
      },
      {
        bucketId: 'watercolor_textured',
        bucketGroupId: 'themes',
        displayString: 'Watercolor & Textured',
        displayRGBAColor: null
      },
      {
        bucketId: 'pink',
        bucketGroupId: 'colors',
        displayString: 'Pink',
        displayRGBAColor: {
          hexString: 'dea3c2ff',
          floatArray: [0.8705882352941177, 0.6392156862745098, 0.7607843137254902, 1]
        }
      }
    ]
  },
  {
    exhibitId: 'b42483f546afaa9ffdc49d4f9b6d0a5aaff459f911746a609a365f2764a52369',
    aspectRatio: 1.6,
    thumbnail: {
      url:
        'https://d2ytcdhzgn2xcf.cloudfront.net/assets/public/designShowcase/1564430193037/b42483f546afaa9ffdc49d4f9b6d0a5aaff459f911746a609a365f2764a52369.png?resize=w800'
    },
    spec: {
      owner: 'Giselle Hudson',
      fiancee: 'Robert Fletcher',
      message: 'And so the adventure begins...',
      style: { id: 'spring_flowers', name: 'Spring Flowers', supportsPrints: false, supportsEcards: true },
      fontName: 'Stalemate',
      primaryPhotoHorizontal: {
        assetId: 'jzLSn58RSq6njuxdxXiA_w_couple_giselle_robert_walking_boardwalk.jpg',
        width: 5760,
        height: 3840
      },
      palette: {
        paletteId: '#f7d6d1-false',
        paletteName: 'My Custom Color',
        accentColor: { hexString: 'f7d6d1ff', floatArray: [0.968627, 0.839216, 0.819608, 1] },
        baseText: { hexString: '000000ff', floatArray: [0, 0, 0, 1] },
        baseColor: { hexString: 'f7d6d1ff', floatArray: [0.968627, 0.839216, 0.819608, 1] },
        accentText: { hexString: '000000ff', floatArray: [0, 0, 0, 1] },
        accentLightText: false,
        baseLightText: false
      },
      usesWeddingColor: false,
      websiteLayout: { template: 'aloha' }
    },
    organizationBuckets: [
      {
        bucketId: 'botanical_nature',
        bucketGroupId: 'themes',
        displayString: 'Nature & Botanical',
        displayRGBAColor: null
      },
      { bucketId: 'floral', bucketGroupId: 'themes', displayString: 'Floral', displayRGBAColor: null },
      {
        bucketId: 'red',
        bucketGroupId: 'colors',
        displayString: 'Red',
        displayRGBAColor: {
          hexString: 'b8564fff',
          floatArray: [0.7215686274509804, 0.33725490196078434, 0.30980392156862746, 1]
        }
      },
      {
        bucketId: 'pink',
        bucketGroupId: 'colors',
        displayString: 'Pink',
        displayRGBAColor: {
          hexString: 'dea3c2ff',
          floatArray: [0.8705882352941177, 0.6392156862745098, 0.7607843137254902, 1]
        }
      },
      {
        bucketId: 'green',
        bucketGroupId: 'colors',
        displayString: 'Green',
        displayRGBAColor: {
          hexString: '9aa493ff',
          floatArray: [0.6039215686274509, 0.6431372549019608, 0.5764705882352941, 1]
        }
      }
    ]
  },
  {
    exhibitId: '0d4ae639256e3b837abbcf1f757d934474da1e13ff5cba17f2634762d713269d',
    aspectRatio: 1.6,
    thumbnail: {
      url:
        'https://d2ytcdhzgn2xcf.cloudfront.net/assets/public/designShowcase/1564430193037/0d4ae639256e3b837abbcf1f757d934474da1e13ff5cba17f2634762d713269d.png?resize=w800'
    },
    spec: {
      owner: 'Harry Moon',
      fiancee: 'Sally Priestley',
      message: 'join us, in an evening under the stars',
      style: { id: 'gold_vines', name: 'Gold Vines', supportsPrints: false, supportsEcards: true },
      fontName: 'Amatic SC',
      primaryPhotoHorizontal: {
        assetId: '3gaBazswQpSCoxwcwQjr_w_couple_harry_sally_corn_field.jpg',
        width: 3705,
        height: 4723
      },
      palette: {
        paletteId: '#49423e-true',
        paletteName: 'My Custom Color',
        accentColor: { hexString: '49423eff', floatArray: [0.286275, 0.258824, 0.243137, 1] },
        baseText: { hexString: 'ffffffff', floatArray: [1, 1, 1, 1] },
        baseColor: { hexString: '49423eff', floatArray: [0.286275, 0.258824, 0.243137, 1] },
        accentText: { hexString: 'ffffffff', floatArray: [1, 1, 1, 1] },
        accentLightText: true,
        baseLightText: true
      },
      usesWeddingColor: false,
      websiteLayout: { template: 'brannan' }
    },
    organizationBuckets: [
      {
        bucketId: 'botanical_nature',
        bucketGroupId: 'themes',
        displayString: 'Nature & Botanical',
        displayRGBAColor: null
      },
      { bucketId: 'rustic_country', bucketGroupId: 'themes', displayString: 'Rustic', displayRGBAColor: null },
      {
        bucketId: 'rose',
        bucketGroupId: 'colors',
        displayString: 'Rose',
        displayRGBAColor: {
          hexString: 'e0bfbeff',
          floatArray: [0.8784313725490196, 0.7490196078431373, 0.7450980392156863, 1]
        }
      },
      {
        bucketId: 'gold',
        bucketGroupId: 'colors',
        displayString: 'Gold',
        displayRGBAColor: {
          hexString: 'dfce85ff',
          floatArray: [0.8745098039215686, 0.807843137254902, 0.5215686274509804, 1]
        }
      },
      {
        bucketId: 'brown',
        bucketGroupId: 'colors',
        displayString: 'Brown',
        displayRGBAColor: {
          hexString: '7e675bff',
          floatArray: [0.49411764705882355, 0.403921568627451, 0.3568627450980392, 1]
        }
      }
    ]
  },
  {
    exhibitId: '8526b86389bc9e2fa5fbb3e2cb7f4cc9f9adc36cb21ec4214a4f12cdb179dd88',
    aspectRatio: 1.6,
    thumbnail: {
      url:
        'https://d2ytcdhzgn2xcf.cloudfront.net/assets/public/designShowcase/1564430193037/8526b86389bc9e2fa5fbb3e2cb7f4cc9f9adc36cb21ec4214a4f12cdb179dd88.png?resize=w800'
    },
    spec: {
      owner: 'Jon Russell',
      fiancee: 'Larissa Rai',
      message: `We can't wait to celebrate with you!`,
      style: { id: 'mount_baker', name: 'Mount Baker', supportsPrints: false, supportsEcards: true },
      fontName: 'Penna Connected',
      primaryPhotoHorizontal: {
        assetId: 'MRmpSPT4GBugxLfwfMzg_b_couple_jon_and_larissa_hike.jpg',
        width: 5040,
        height: 3360
      },
      palette: {
        paletteId: '#43556c-false',
        paletteName: 'My Custom Color',
        accentColor: { hexString: '43556cff', floatArray: [0.262745, 0.333333, 0.423529, 1] },
        baseText: { hexString: '000000ff', floatArray: [0, 0, 0, 1] },
        baseColor: { hexString: '43556cff', floatArray: [0.262745, 0.333333, 0.423529, 1] },
        accentText: { hexString: '000000ff', floatArray: [0, 0, 0, 1] },
        accentLightText: false,
        baseLightText: false
      },
      usesWeddingColor: false,
      websiteLayout: { template: 'aloha' }
    },
    organizationBuckets: [
      {
        bucketId: 'botanical_nature',
        bucketGroupId: 'themes',
        displayString: 'Nature & Botanical',
        displayRGBAColor: null
      },
      { bucketId: 'destination', bucketGroupId: 'themes', displayString: 'Destination', displayRGBAColor: null },
      {
        bucketId: 'watercolor_textured',
        bucketGroupId: 'themes',
        displayString: 'Watercolor & Textured',
        displayRGBAColor: null
      },
      {
        bucketId: 'blue',
        bucketGroupId: 'colors',
        displayString: 'Blue',
        displayRGBAColor: {
          hexString: '7096c5ff',
          floatArray: [0.4392156862745098, 0.5882352941176471, 0.7725490196078432, 1]
        }
      },
      {
        bucketId: 'beige',
        bucketGroupId: 'colors',
        displayString: 'Beige',
        displayRGBAColor: {
          hexString: 'efeee2ff',
          floatArray: [0.9372549019607843, 0.9333333333333333, 0.8862745098039215, 1]
        }
      }
    ]
  },
  {
    exhibitId: '4c76c7d055c9e643e85a07b3df47cc848fdb583e37d9d9255134e0674580b033',
    aspectRatio: 1.6,
    thumbnail: {
      url:
        'https://d2ytcdhzgn2xcf.cloudfront.net/assets/public/designShowcase/1564430193037/4c76c7d055c9e643e85a07b3df47cc848fdb583e37d9d9255134e0674580b033.png?resize=w800'
    },
    spec: {
      owner: 'Jon Russell',
      fiancee: 'Larissa Rai',
      message: `We can't wait to celebrate with you!`,
      style: { id: 'northwest', name: 'The Northwest', supportsPrints: false, supportsEcards: true },
      fontName: 'Penna Connected',
      primaryPhotoHorizontal: {
        assetId: 'MRmpSPT4GBugxLfwfMzg_b_couple_jon_and_larissa_hike.jpg',
        width: 5040,
        height: 3360
      },
      palette: {
        paletteId: '#43556c-false',
        paletteName: 'My Custom Color',
        accentColor: { hexString: '43556cff', floatArray: [0.262745, 0.333333, 0.423529, 1] },
        baseText: { hexString: '000000ff', floatArray: [0, 0, 0, 1] },
        baseColor: { hexString: '43556cff', floatArray: [0.262745, 0.333333, 0.423529, 1] },
        accentText: { hexString: '000000ff', floatArray: [0, 0, 0, 1] },
        accentLightText: false,
        baseLightText: false
      },
      usesWeddingColor: false,
      websiteLayout: { template: 'aloha' }
    },
    organizationBuckets: [
      {
        bucketId: 'botanical_nature',
        bucketGroupId: 'themes',
        displayString: 'Nature & Botanical',
        displayRGBAColor: null
      },
      { bucketId: 'destination', bucketGroupId: 'themes', displayString: 'Destination', displayRGBAColor: null },
      {
        bucketId: 'green',
        bucketGroupId: 'colors',
        displayString: 'Green',
        displayRGBAColor: {
          hexString: '9aa493ff',
          floatArray: [0.6039215686274509, 0.6431372549019608, 0.5764705882352941, 1]
        }
      },
      {
        bucketId: 'beige',
        bucketGroupId: 'colors',
        displayString: 'Beige',
        displayRGBAColor: {
          hexString: 'efeee2ff',
          floatArray: [0.9372549019607843, 0.9333333333333333, 0.8862745098039215, 1]
        }
      }
    ]
  },
  {
    exhibitId: 'ec404d623ccedc0e436b1b73f39ebc4fd7d101c077d5058c4c9b5d09353d2a1a',
    aspectRatio: 1.6,
    thumbnail: {
      url:
        'https://d2ytcdhzgn2xcf.cloudfront.net/assets/public/designShowcase/1564430193037/ec404d623ccedc0e436b1b73f39ebc4fd7d101c077d5058c4c9b5d09353d2a1a.png?resize=w800'
    },
    spec: {
      owner: 'Dan Benjamin',
      fiancee: 'José Santos',
      message: `We can't wait to celebrate with you!`,
      style: { id: 'captain_warren_abdul', name: 'Captain Warren Abdul', supportsPrints: false, supportsEcards: true },
      fontName: 'AW Conqueror Carved',
      primaryPhotoHorizontal: {
        assetId: 'JSeXyoZSSIylfJwoAemk_g_couple_dan_jose_hugging_beach.jpg',
        width: 3648,
        height: 5472
      },
      palette: {
        paletteId: '#f8f8f0-false',
        paletteName: 'My Custom Color',
        accentColor: { hexString: 'f8f8f0ff', floatArray: [0.972549, 0.972549, 0.941176, 1] },
        baseText: { hexString: '000000ff', floatArray: [0, 0, 0, 1] },
        baseColor: { hexString: 'f8f8f0ff', floatArray: [0.972549, 0.972549, 0.941176, 1] },
        accentText: { hexString: '000000ff', floatArray: [0, 0, 0, 1] },
        accentLightText: false,
        baseLightText: false
      },
      usesWeddingColor: false,
      websiteLayout: { template: 'aloha' }
    },
    organizationBuckets: [
      { bucketId: 'destination', bucketGroupId: 'themes', displayString: 'Destination', displayRGBAColor: null },
      {
        bucketId: 'beige',
        bucketGroupId: 'colors',
        displayString: 'Beige',
        displayRGBAColor: {
          hexString: 'efeee2ff',
          floatArray: [0.9372549019607843, 0.9333333333333333, 0.8862745098039215, 1]
        }
      },
      {
        bucketId: 'blue',
        bucketGroupId: 'colors',
        displayString: 'Blue',
        displayRGBAColor: {
          hexString: '7096c5ff',
          floatArray: [0.4392156862745098, 0.5882352941176471, 0.7725490196078432, 1]
        }
      }
    ]
  },
  {
    exhibitId: '630c3f2d5040850febaadbc86134660cdc951fee52da3cc92251471e8a8f4777',
    aspectRatio: 1.6,
    thumbnail: {
      url:
        'https://d2ytcdhzgn2xcf.cloudfront.net/assets/public/designShowcase/1564430193037/630c3f2d5040850febaadbc86134660cdc951fee52da3cc92251471e8a8f4777.png?resize=w800'
    },
    spec: {
      owner: 'Harry Moon',
      fiancee: 'Sally Priestley',
      message: 'join us, in an evening under the stars',
      style: { id: 'bronzed_leaves', name: 'Bronzed Leaves', supportsPrints: false, supportsEcards: true },
      fontName: 'Amatic SC',
      primaryPhotoHorizontal: {
        assetId: '3gaBazswQpSCoxwcwQjr_w_couple_harry_sally_corn_field.jpg',
        width: 3705,
        height: 4723
      },
      palette: {
        paletteId: '#f2f2f2-false',
        paletteName: 'My Custom Color',
        accentColor: { hexString: 'f2f2f2ff', floatArray: [0.94902, 0.94902, 0.94902, 1] },
        baseText: { hexString: '000000ff', floatArray: [0, 0, 0, 1] },
        baseColor: { hexString: 'f2f2f2ff', floatArray: [0.94902, 0.94902, 0.94902, 1] },
        accentText: { hexString: '000000ff', floatArray: [0, 0, 0, 1] },
        accentLightText: false,
        baseLightText: false
      },
      usesWeddingColor: false,
      websiteLayout: { template: 'brannan' }
    },
    organizationBuckets: [
      {
        bucketId: 'botanical_nature',
        bucketGroupId: 'themes',
        displayString: 'Nature & Botanical',
        displayRGBAColor: null
      },
      { bucketId: 'seasons', bucketGroupId: 'themes', displayString: 'Seasonal', displayRGBAColor: null },
      {
        bucketId: 'beige',
        bucketGroupId: 'colors',
        displayString: 'Beige',
        displayRGBAColor: {
          hexString: 'efeee2ff',
          floatArray: [0.9372549019607843, 0.9333333333333333, 0.8862745098039215, 1]
        }
      },
      {
        bucketId: 'grey',
        bucketGroupId: 'colors',
        displayString: 'Grey',
        displayRGBAColor: {
          hexString: 'ddddddff',
          floatArray: [0.8666666666666667, 0.8666666666666667, 0.8666666666666667, 1]
        }
      },
      {
        bucketId: 'brown',
        bucketGroupId: 'colors',
        displayString: 'Brown',
        displayRGBAColor: {
          hexString: '7e675bff',
          floatArray: [0.49411764705882355, 0.403921568627451, 0.3568627450980392, 1]
        }
      }
    ]
  }
];
